export const PAGE_SIZE = 10;

/** Fulfillment queue (GET /v1/admin/orders/lists/active). */
export const ACTIVE_ORDER_STATUSES = [
  'PENDING',
  'CONFIRMED',
  'PREPARING',
  'READY_FOR_PICKUP',
  'ON_THE_WAY',
];

/** Closed orders (GET /v1/admin/orders/lists/history). */
export const HISTORY_ORDER_STATUSES = ['DELIVERED', 'REFUNDED', 'CANCELLED'];

/** @deprecated Use ACTIVE_ORDER_STATUSES or HISTORY_ORDER_STATUSES */
export const ORDER_STATUSES = [...ACTIVE_ORDER_STATUSES, ...HISTORY_ORDER_STATUSES];

export const TICKET_STATUSES = ['OPEN', 'IN_PROGRESS', 'CLOSED'];

const inrFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Format amount in Indian Rupees (₹). */
export function formatMoney(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return inrFormatter.format(Number(n));
}

function parseIsoDate(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^-?\d+$/.test(trimmed)) {
      value = Number(trimmed);
    }
  }

  try {
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? date : null;
  } catch {
    return null;
  }
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidDate(value) {
  return Boolean(parseIsoDate(value));
}

/**
 * @param {unknown} iso
 * @returns {string}
 */
export function formatDate(iso) {
  const date = parseIsoDate(iso);
  if (!date) return '—';
  return date.toLocaleString();
}

/** Date line for order "placed" cells (e.g. Fri, May 15, 2026). */
export function formatPlacedDate(iso) {
  const date = parseIsoDate(iso);
  if (!date) return '—';
  return date.toLocaleDateString(undefined, {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** Time line with AM/PM (e.g. 2:30 PM). */
export function formatPlacedTime(iso) {
  const date = parseIsoDate(iso);
  if (!date) return '';
  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

/** Short clock time for timelines (e.g. 2:30 PM). */
export function formatTimeShort(iso) {
  const date = parseIsoDate(iso);
  if (!date) return '';
  return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
}

/**
 * Render email from string or `{ address }` / `{ value }` API shapes.
 * @param {unknown} email
 * @returns {string}
 */
export function formatEmailField(email) {
  if (email == null) return '—';
  if (typeof email === 'string') return email;
  if (typeof email === 'object' && email !== null) {
    if (typeof email.address === 'string') return email.address;
    if (typeof email.value === 'string') return email.value;
  }
  return JSON.stringify(email);
}
